import React from 'react'
import { ApplicationLoaderPublicProps, ApplicationLoaderRenderProps } from '.'
import { ApplicationLoader } from './application-loader'

export const ApplicationLoaderCacheFirst = ({
  organizationID,
  applicationID,
  renderLoaded,
  renderLoading
}: ApplicationLoaderPublicProps & ApplicationLoaderRenderProps) => (
  <ApplicationLoader
    organizationID={organizationID}
    applicationID={applicationID}
    fetchPolicy="cache-first"
    renderLoading={renderLoading}
    renderLoaded={renderLoaded}
  />
)
